var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownThin = function SvgArrowDownThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9008 0V34M0.476562 22.1L14.9008 34L28.4766 22.1",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgArrowDownThin;